import { MouseEvent } from 'react';
import { useDrawer } from '@components/Drawer';

export const useToggle = () => {
  const {
    open: isDrawerOpen,
    toggleDrawer,
    closeDrawer,
    openDrawer,
  } = useDrawer();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    //e.stopPropagation();
    e.preventDefault();

    toggleDrawer();
  };

  return {
    isOpen: isDrawerOpen,
    handleClick,
    handleClose: closeDrawer,
    handleOpen: openDrawer,
  };
};
